'use client';

import { c as _c } from "react/compiler-runtime";
import { SearchInput } from '@/components/Search/SearchInput';
import { SEARCH_CONSTANTS } from '@/constants';
import { Transition } from '@headlessui/react';
import { SearchIcon } from '@tallinn-arvudes/ui/atoms/icons/search-icon';
import { Button } from '@tallinn-arvudes/ui/tallinn-design/Button';
import { cn } from '@tallinn-arvudes/ui/utils';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { type RefObject, useCallback, useEffect, useRef, useState } from 'react';
import { useDebounceValue, useOnClickOutside } from 'usehooks-ts';
const {
  QUERY_PARAM,
  PAGE_PARAM,
  SEARCH_BASE_URL,
  INPUT_MAX_LENGTH
} = SEARCH_CONSTANTS;
export const SearchForm = t0 => {
  const $ = _c(57);
  const {
    buttonClassName
  } = t0;
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname) {
    t1 = pathname.startsWith(SEARCH_BASE_URL);
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [isSearchActive, setIsSearchActive] = useState(t1);
  let t2;
  if ($[2] !== searchParams) {
    t2 = searchParams.get(QUERY_PARAM)?.trim() ?? "";
    $[2] = searchParams;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const query = t2;
  const [value, setValue] = useState(query);
  const [debouncedValue, updateDebouncedValue] = useDebounceValue(value, 500);
  let t3;
  if ($[4] !== updateDebouncedValue) {
    t3 = newValue => {
      setValue(newValue);
      updateDebouncedValue(newValue);
    };
    $[4] = updateDebouncedValue;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const updateValue = t3;
  const searchContainerRef = useRef(null);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setIsSearchActive(false);
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  useOnClickOutside(searchContainerRef as RefObject<HTMLDivElement>, t4);
  let t5;
  if ($[7] !== pathname || $[8] !== searchParams) {
    t5 = () => {
      if (pathname.startsWith(SEARCH_BASE_URL) && !searchParams.get(QUERY_PARAM)?.trim()) {
        setIsSearchActive(true);
      }
    };
    $[7] = pathname;
    $[8] = searchParams;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== pathname || $[11] !== searchParams || $[12] !== value) {
    t6 = [pathname, searchParams, value];
    $[10] = pathname;
    $[11] = searchParams;
    $[12] = value;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  useEffect(t5, t6);
  let t7;
  if ($[14] !== searchParams) {
    t7 = () => {
      if (!searchParams.get(QUERY_PARAM)?.trim()) {
        setValue("");
      }
    };
    $[14] = searchParams;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== pathname || $[17] !== searchParams) {
    t8 = [pathname, searchParams];
    $[16] = pathname;
    $[17] = searchParams;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[19] !== updateValue) {
    t9 = () => {
      const handler = () => {
        const queryValue = new URLSearchParams(window.location.search).get(QUERY_PARAM) ?? "";
        updateValue(queryValue);
      };
      window.addEventListener("popstate", handler, false);
      return () => {
        window.removeEventListener("popstate", handler, false);
      };
    };
    t10 = [updateValue];
    $[19] = updateValue;
    $[20] = t10;
    $[21] = t9;
  } else {
    t10 = $[20];
    t9 = $[21];
  }
  useEffect(t9, t10);
  let t11;
  if ($[22] !== pathname || $[23] !== router || $[24] !== searchParams) {
    t11 = term => {
      const params = new URLSearchParams(searchParams);
      params.delete(PAGE_PARAM);
      if (term) {
        params.set(QUERY_PARAM, term);
      } else {
        params.delete(QUERY_PARAM);
      }
      const nextPath = `${SEARCH_BASE_URL}?${params.toString()}`;
      if (pathname === nextPath || term.length > INPUT_MAX_LENGTH) {
        return;
      }
      setIsSearchActive(false);
      router.push(nextPath);
    };
    $[22] = pathname;
    $[23] = router;
    $[24] = searchParams;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const handleSearch = t11;
  let t12;
  if ($[26] !== pathname || $[27] !== router || $[28] !== updateValue) {
    t12 = () => {
      updateValue("");
      router.push(pathname);
    };
    $[26] = pathname;
    $[27] = router;
    $[28] = updateValue;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  const handleClear = t12;
  let t13;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => setIsSearchActive(_temp);
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== buttonClassName || $[32] !== isSearchActive) {
    t14 = cn("z-10 ml-auto text-white transition motion-reduce:transition-none opacity-100", buttonClassName, {
      "opacity-0": isSearchActive
    });
    $[31] = buttonClassName;
    $[32] = isSearchActive;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <SearchIcon />;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t14) {
    t16 = <Button variant="icon" onClick={t13} aria-label="Ava otsing" className={t14}>{t15}</Button>;
    $[35] = t14;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = cn("z-10 pl-1 right-0.5 top-0.5 flex w-full h-full transition-all motion-reduce:transition-none duration-300 absolute md:h-auto md:top-auto md:-mr-4 md:pr-4 md:ml-0 opacity-100", "data-[closed]:w-36", "data-[closed]:opacity-0");
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== handleSearch || $[39] !== value) {
    t18 = () => {
      handleSearch(value);
    };
    $[38] = handleSearch;
    $[39] = value;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== updateValue) {
    t19 = value_0 => {
      updateValue(value_0);
    };
    $[41] = updateValue;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = () => {
      setIsSearchActive(false);
    };
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  const t21 = !!query;
  let t22;
  if ($[44] !== debouncedValue || $[45] !== handleClear || $[46] !== t18 || $[47] !== t19 || $[48] !== t21 || $[49] !== value) {
    t22 = <div ref={searchContainerRef} className={t17}><SearchInput value={value} debouncedValue={debouncedValue} triggerSearch={t18} onChange={t19} onClose={t20} onClear={handleClear} showClearBtn={t21} autoFocus={true} maxLength={INPUT_MAX_LENGTH} /></div>;
    $[44] = debouncedValue;
    $[45] = handleClear;
    $[46] = t18;
    $[47] = t19;
    $[48] = t21;
    $[49] = value;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== isSearchActive || $[52] !== t22) {
    t23 = <Transition show={isSearchActive}>{t22}</Transition>;
    $[51] = isSearchActive;
    $[52] = t22;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t16 || $[55] !== t23) {
    t24 = <>{t16}{t23}</>;
    $[54] = t16;
    $[55] = t23;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  return t24;
};
function _temp(prev) {
  return !prev;
}